import React, { Fragment, memo, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { IncentiveModalInfo } from 'client/site-modules/shared/components/incentives/incentive-modal-info/incentive-modal-info';

import './prise-checker-incentive-info-modal.scss';

export const PriceCheckerIncentiveInfoModal = memo(
  ({ restrictions, startDate = null, endDate = null, rebateAmount = null, incentiveTitle, infoClasses = '' }) => {
    const [isModalOpen, setModal] = useState(false);

    function toggleModal() {
      return setModal(!isModalOpen);
    }

    return (
      <Fragment>
        <button
          type="button"
          className={classNames('price-checker-incentive-info-btn ms-0 btn btn-sm p-0', infoClasses)}
          onClick={toggleModal}
          aria-label={`Open the description of ${incentiveTitle}`}
        >
          <i className="icon-info" aria-hidden="true" />
        </button>
        <Modal
          modalClassName="price-checker-incentive-info"
          contentClassName="modal-content"
          isOpen={isModalOpen}
          toggle={toggleModal}
        >
          <button className="modal-close-button p-0 btn btn-link" onClick={toggleModal}>
            <i className="icon-cross3 close-icon" aria-label="close" />
          </button>
          <ModalBody>
            <IncentiveModalInfo
              restrictions={restrictions}
              startDate={startDate}
              endDate={endDate}
              rebateAmount={rebateAmount}
              isVdp
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
);

PriceCheckerIncentiveInfoModal.displayName = 'PriceCheckerIncentiveInfoModal';

PriceCheckerIncentiveInfoModal.propTypes = {
  endDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rebateAmount: PropTypes.number,
  restrictions: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  incentiveTitle: PropTypes.string.isRequired,
  infoClasses: PropTypes.string,
};
